import {CopilotAuthTokenProvider} from './copilot-auth-token'

export const AGENT_SESSIONS_TOKEN_KEY = 'AGENT_SESSIONS_TOKEN'

export class AgentSessionsTokenProvider extends CopilotAuthTokenProvider {
  constructor() {
    const tokenEndpoint = `/copilot/agent-sessions/token`
    super([], tokenEndpoint, AGENT_SESSIONS_TOKEN_KEY)
  }
}
